import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { type ListaItens, type SeletorItem } from '@Lar21/imaginii-web-components/vue'
import { encontrarOpcaoDoCatalogo, preservarEstadoSemSelecaoVazia, prepararEstadoSomenteLeitura } from '@next/compartilhados/catalogos/apresentacao/estado-seletor-catalogo'
import {
  CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO,
  criarEstadoSeletorCatalogoGrupoDeLocaisDeTrabalho,
  criarPropriedadesPontotelSeletorGrupoDeLocaisDeTrabalho,
  extrairValorDoSeletorCatalogoGrupoDeLocaisDeTrabalho,
  filtrarOpcoesGrupoDeLocaisDeTrabalho,
} from './adaptador-catalogo-grupo-de-locais-de-trabalho'
import { usarCatalogoGrupoDeLocaisDeTrabalho } from './usar-catalogo-grupo-de-locais-de-trabalho'
import type {
  FiltrosCatalogoGrupoDeLocaisDeTrabalho,
  OpcaoGrupoDeLocaisDeTrabalho,
  SelecaoCatalogoGrupoDeLocaisDeTrabalho,
} from '../catalogo-grupo-de-locais-de-trabalho.tipos'

type Props = Readonly<{
  modelValue: SelecaoCatalogoGrupoDeLocaisDeTrabalho
  selecaoMultipla?: boolean
  tamanho?: 'P' | 'M' | 'G'
  filtros?: FiltrosCatalogoGrupoDeLocaisDeTrabalho
  predicado?: (opcao: OpcaoGrupoDeLocaisDeTrabalho) => boolean
  desabilitado?: boolean
  somenteLeitura?: boolean
  permiteSelecionarTodos?: boolean
  permiteLimpar?: boolean
  habilitarDuploClique?: boolean
  label?: string
  placeholder?: string
  mensagemErro?: string | null
}>


export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogoGrupoDeLocaisDeTrabalho',
  props: {
    modelValue: { type: [Object, Array, null], required: true },
    selecaoMultipla: { type: Boolean, required: false, default: false },
    tamanho: { type: String, required: false, default: 'M' },
    filtros: { type: Object, required: false },
    predicado: { type: Function, required: false },
    desabilitado: { type: Boolean, required: false, default: false },
    somenteLeitura: { type: Boolean, required: false, default: false },
    permiteSelecionarTodos: { type: Boolean, required: false, default: true },
    permiteLimpar: { type: Boolean, required: false, default: true },
    habilitarDuploClique: { type: Boolean, required: false, default: false },
    label: { type: String, required: false },
    placeholder: { type: String, required: false },
    mensagemErro: { type: [String, null], required: false, default: null }
  },
  emits: ["update:modelValue", "filtrando-itens", "duplo-clique", "update:selecionouTodos"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props
const emit = __emit
const { t } = useI18n()
const catalogo = usarCatalogoGrupoDeLocaisDeTrabalho(computed(() => !props.somenteLeitura))
const opcoes = computed(() => filtrarOpcoesGrupoDeLocaisDeTrabalho(
  catalogo.itens.value,
  props.filtros,
  props.predicado,
))
const estado = computed(() => prepararEstadoSomenteLeitura(
  criarEstadoSeletorCatalogoGrupoDeLocaisDeTrabalho(
    opcoes.value,
    props.modelValue,
    props.selecaoMultipla,
  ),
  props.somenteLeitura,
  props.modelValue,
))
const erro = computed(() => catalogo.erro.value
  ? t(`${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.erroBusca`)
  : props.mensagemErro)
const propriedades = computed(() => (
  criarPropriedadesPontotelSeletorGrupoDeLocaisDeTrabalho({
    traduzir: t,
    ...(props.label !== undefined ? { label: props.label } : {}),
    ...(props.placeholder !== undefined ? { placeholder: props.placeholder } : {}),
    erro: erro.value,
  })
))
const alterarSelecao = (novoEstado: ListaItens): void => { emit(
  'update:modelValue',
  extrairValorDoSeletorCatalogoGrupoDeLocaisDeTrabalho(
    preservarEstadoSemSelecaoVazia(novoEstado, estado.value, props.permiteLimpar),
    opcoes.value,
    props.selecaoMultipla,
  ),
); }
const tratarDuploClique = (item: SeletorItem): void => {
  const opcao = encontrarOpcaoDoCatalogo(opcoes.value, item)
  if (opcao) emit('duplo-clique', opcao)
}

const __returned__ = { props, emit, t, catalogo, opcoes, estado, erro, propriedades, alterarSelecao, tratarDuploClique }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})